import React from "react";
import NavBar from "./components/navBar";
import Footer from "./components/footer";
import ChatBot from "./components/chatBot";

import "./App.css";
import AppRoutes from "./AppRoutes";
import ScrollToTop from "./lib/scrollToTop";
import { useLocation } from "react-router-dom";

const App = () => {
  const location = useLocation();
  const isRootPath = location.pathname === "/";

  return (
    <div className="App">
      <NavBar />
      <ScrollToTop />
      <AppRoutes />
      <ChatBot />
      <Footer showFullFooter={isRootPath} />
    </div>
  );
};

export default App;
